import { render, staticRenderFns } from "./ViewFilter.vue?vue&type=template&id=b2b23b7c&"
import script from "./ViewFilter.vue?vue&type=script&lang=js&"
export * from "./ViewFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports